<script lang="ts">
	import { ImageModifier } from "luxedo-image-modifier"
	import { getContext } from "svelte"
	import { SnapshotModifierController } from "./SnapshotModifierController.svelte"
	import { ImageModifyMaskRepo as MaskRepo } from "@calibration/masking"
	import { getEditor } from "luxedo-canvas"

	const controller = getContext<SnapshotModifierController>("controller")
	const maskRepo = new MaskRepo(getEditor(), controller.selectedSnapshot)
</script>

<ImageModifier
	imgSrc={controller.selectedSnapshot.src}
	imgRes={controller.selectedSnapshot.resolution}
	{maskRepo}
	onCancel={() => controller.setView("select")}
	onSave={(blob) => controller.saveSnapshot(blob)}
/>

<style>
</style>
